module.exports = __webpack_public_path__ + "assets/img/ztWenAnPNG-42b16668.png";